import styled from "styled-components"
import BrandAvatar from "@irati/ui/src/BrandAvatar"

export default styled(BrandAvatar)`
  object-fit: contain;
  border-radius: ${({theme}) => theme.border.radius.large};
  width: 64px;
  height: 64px;
`
